const CACHE_KEY = 'crm_geocode_cache_v4';
const MAX_ENTRIES = 4000;

let memoryCache = null;
let persistTimeoutId = null;

const createEmptyCache = () => ({});

const trimCache = (cache) => {
  const entries = Object.entries(cache);
  if (entries.length <= MAX_ENTRIES) return cache;
  return Object.fromEntries(entries.slice(-MAX_ENTRIES));
};

const loadMemoryCache = () => {
  if (memoryCache) return memoryCache;

  try {
    const raw = localStorage.getItem(CACHE_KEY);
    memoryCache = raw ? JSON.parse(raw) : createEmptyCache();
  } catch {
    memoryCache = createEmptyCache();
  }

  return memoryCache;
};

const schedulePersist = () => {
  if (persistTimeoutId !== null) {
    window.clearTimeout(persistTimeoutId);
  }

  persistTimeoutId = window.setTimeout(() => {
    persistTimeoutId = null;
    try {
      const cache = loadMemoryCache();
      localStorage.setItem(CACHE_KEY, JSON.stringify(trimCache(cache)));
    } catch {
      // ignore quota errors
    }
  }, 400);
};

export const getCachedGeocode = (query) => {
  if (!query) return null;
  const cache = loadMemoryCache();
  return cache[query] || null;
};

export const setCachedGeocode = (query, coords) => {
  if (!query || !coords) return;
  const cache = loadMemoryCache();
  cache[query] = coords;
  schedulePersist();
};

export const clearGeocodeCache = () => {
  memoryCache = createEmptyCache();
  localStorage.removeItem(CACHE_KEY);
};

// Backward-compatible no-ops: failure cache caused many false positives.
export const isCachedGeocodeFailure = () => false;
export const setCachedGeocodeFailure = () => {};
